import * as $ from "jquery";
import {
    clearControlState,
    loadControlState,
    saveControlState,
} from "./formtools";

const KEY = "liveonlinedatefilter";

export class LiveOnlineScheduleFilter {
    $dropdown: JQuery;
    constructor($dropdown: JQuery) {
        const self = this;
        this.$dropdown = $dropdown;
        loadControlState($dropdown, KEY);

        this.$dropdown.on("change", function () {
            saveControlState($dropdown, KEY);
            self.applyFilter();
        });

        self.applyFilter();
    }

    private applyFilter() {
        const filterval = <string> this.$dropdown.val();
        if (filterval) {
            $(".term").hide();
            $(".termdate-" + filterval).show();
        } else {
            $(".term").show();
        }
    }
}
